import {combineReducers} from "redux"
import {reducer as formReducer} from "redux-form"
import {authSlice} from "scholastic-client-components/src/slices/authSlice"
import {notificationListSlice} from "scholastic-client-components/src/slices/notificationListSlice"

import {trialEditSlice} from "../slices/trialEditSlice"
import {changeLanguageSlice} from "../slices/changeLanguageSlice"

export const rootReducer = combineReducers({
    auth: authSlice.reducer,
    form: formReducer,
    notificationList: notificationListSlice.reducer,
    trialNetworks: trialEditSlice.reducer,
    changeLanguage: changeLanguageSlice.reducer,
})

export type RootState = ReturnType<typeof rootReducer>
